import { IntlShape } from 'react-intl';
import { messages } from './messages';

const Schema = (intl: IntlShape) => ({
  title: intl.formatMessage(messages.Application),
  fieldsets: [
    {
      id: 'default',
      title: 'Default',
      fields: ['sort_by_folder_position'],
    },
  ],

  properties: {
    sort_by_folder_position: {
      title: intl.formatMessage(messages.SortLabel),
      description: intl.formatMessage(messages.SortHelp),
      type: 'boolean',
      default: false,
    },
  },
  required: [],
});

export default Schema;
